export default __webpack_public_path__ + "static/media/blog-img-2.f101d5d5.jpg";